/* Main Controller
** Author: Soc-dfsk -30
** Version: 1.0
** Date 10/01/2017 */
'use strict';
App.controller('MainCtrl', ['$rootScope', '$scope', '$http', '$cookies', '$cookieStore', 'ngDialog', '$timeout', 'toastr', 'Api', '$log', '$localStorage', '$loading', '$state', '$sessionStorage', 'sessionService',
    function ($rootScope, $scope, $http, $cookies, $cookieStore, ngDialog, $timeout, toastr, Api, $log, $localStorage, $loading, $state, $sessionStorage, sessionService) {
        $scope.uiRouterState = $state;
        $scope.user = {};
        $scope.cpassword = '';
        $scope.newPassword = '';
        $scope.cacheBustingParam = Date.now();
        $scope.logoImage = $localStorage['logoImage'];

        $scope.subscription = sessionService.notifications
            .subscribe((data) => $scope.user.notificationCount = _.get(data, 'unreadCount', 0));
        $scope.$on('$destroy', $scope.subscription);
        /* Resize angular material tab when window resize */
        $scope.$on('$viewContentLoaded', function () {
            var windowH = $(window).width();
            var wrapperH = $('#nav-bar-content md-tabs-wrapper').width();
            var startwidth = windowH - 345;
            if (windowH > wrapperH) {
                $('#nav-bar-content md-tabs-wrapper').css('width', (startwidth) + 'px');
            }

            $(window).scroll(function () {
                if ($state.current.name != 'nurseProfile') {
                    if ($(window).innerWidth() <= 991) {
                        if ($state.current.name === "dashboard.jobs") {
                            if ($(this).scrollTop() > 300) {
                                $('#nav-bar-content md-tabs-wrapper').addClass("sticky");
                            }
                            if ($(this).scrollTop() < 260) {
                                $('#nav-bar-content md-tabs-wrapper').removeClass("sticky");
                            }
                        }
                        else {
                            if ($(this).scrollTop() > 1) {
                                $('#nav-bar-content md-tabs-wrapper').addClass("sticky");
                            }
                            if ($(this).scrollTop() < 230) {
                                $('#nav-bar-content md-tabs-wrapper').removeClass("sticky");
                            }
                        }
                    } else {
                        if ($state.current.name === "dashboard.jobs") {
                            if ($(this).scrollTop() > 400) {
                                $('#nav-bar-content md-tabs-wrapper').addClass("sticky");
                            }
                            if ($(this).scrollTop() < 230) {
                                $('#nav-bar-content md-tabs-wrapper').removeClass("sticky");
                            }
                        }
                        else {
                            if ($(this).scrollTop() > 1) {
                                $('#nav-bar-content md-tabs-wrapper').addClass("sticky");
                            }
                            if ($(this).scrollTop() < 230) {
                                $('#nav-bar-content md-tabs-wrapper').removeClass("sticky");
                            }
                        }
                    }
                }

            });

            $(window).resize(function () {
                var windowH = $(window).width();
                var wrapperH = $('#nav-bar-content md-tabs-wrapper').width();
                var differenceH = windowH - wrapperH;
                var newH = wrapperH + differenceH;
                var truecontentH = $('#truecontent').width();
                if (windowH > truecontentH) {
                    $('#nav-bar-content md-tabs-wrapper').css('width', (newH) + 'px');
                }
                var fwidth = windowH - 344;
                if (document.getElementById("wrapper1")) {
                    document.getElementById("wrapper1").innerHTML = fwidth;
                }
                $('#nav-bar-content md-tabs-wrapper').css('width', (fwidth) + 'px');
            })

        });

        function updateData(userData) {
            if (userData) {
                $scope.user.firstName = userData.firstName;
                $scope.user.lastName = userData.lastName;
                $scope.user.email = userData.email;
                if (userData.phoneNumber) {
                        const phoneNumber = userData.phoneNumber.toString();
                        $scope.user.phoneNumber = [phoneNumber.slice(0, 3), '-', phoneNumber.slice(3, 6), '-', phoneNumber.slice(6)].join('');
                }
                $scope.user.currentStep = userData.currentStep;
                $scope.user.address = userData.address;
                $scope.experienceOfYear = ['Less than 1 Year Experience', '1 to 2 Years Experience', '2 to 3 Years Experience', '3 to 5 Years Experience', '5 to 10 Years Experience', 'Greater than 10 Years Experience'];
                $scope.isEditProfile = false;
                $scope.isComplete = !!_.get(userData, 'briefcase.completedAt', false);
                $scope.profilePic = userData.profilePicUrl || 'img/profileImage.png';
                $scope.user.profilePic = $scope.profilePic;
                $scope.cacheBustingParam = Date.now();
                $scope.additionalCertifications = _.get(userData, 'briefcase.additionalCertifications', []);
                $scope.specialties = _.get(userData, 'briefcase.specialties', []);
                $scope.licenses = _.get(userData, 'briefcase.licenses', []);
                $scope.certifications = _.get(userData, 'briefcase.certifications', []);
                $scope.educationLevel = _.get(userData, 'briefcase.educationLevel');
                $scope.yearsOfExperience = _.get(userData, 'briefcase.yearsOfExperience');
                $scope.affiliations = userData.affiliations ? userData.affiliations.map(i => i.organization.name) : [];
                $scope.isMarketplace = !!userData.isMarketplace;
            }
        }

        $scope.subscription = sessionService.professionalData.subscribe(updateData.bind(this));
        $scope.$on('$destroy', $scope.subscription);

        var throttle = function (func, wait) {
            var context, args, timeout, result;
            var previous = 0;
            var later = function () {
                previous = new Date();
                timeout = null;
                result = func.apply(context, args);
            };
            return function () {
                var now = new Date();
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0) {
                    clearTimeout(timeout);
                    timeout = null;
                    previous = now;
                    result = func.apply(context, args);
                } else if (!timeout) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        };

        if (!$scope.notificationSocket) {
            $scope.notificationSocket = new PushClient.Connection({
                url: Api.ws,
                timeout: 30000,
                authToken: $localStorage['token'],
                onOpen:() => {
                    console.log('Connected');
                },
                onClose:() => {
                    console.log('Disconnected');
                },
                onMessage: throttle((data) => {
                    $scope.$apply(function () {
                        $scope.user.notificationCount = $scope.user.notificationCount ? $scope.user.notificationCount + 1 : 1;
                        $localStorage.notificationCount = $scope.user.notificationCount;
                        $scope.$broadcast('newNotification', { count: $scope.user.notificationCount });
                    })
                    toastr.info(data.text, 'You have new notification', {
                        closeButton: true,
                        closeHtml: '<button class="toast-cross">x</button>',
                        iconClass: 'toast-bg',
                        showMethod: 'slideDown',
                        hideMethod: 'slideUp'
                    });
                })
            });
    
            $scope.$on('$destroy', function () {
                $scope.notificationSocket.close();
            });
        }

    }]);
